'use strict';

var angular = require('angular');
function DynamicClassDirective($window) {
  var win = angular.element($window);
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var dynamicClass = attrs.rmDynamicClass;
      var offsetChange = parseInt(attrs.rmDynamicClassOffset);
      win.on('scroll', function () {
        element[$window.pageYOffset > offsetChange ? 'addClass' : 'removeClass'](dynamicClass);
      });
    }
  };
}
DynamicClassDirective.$inject = ['$window'];
module.exports = DynamicClassDirective;